// Core
import {useState, useEffect} from 'react';
import {useQuery} from 'react-query';

// Chakra 
import {

    Button,
    Divider,
    Flex,
    FormControl,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    Text,
    Select,
    Checkbox,
} from '@chakra-ui/react';

// Assets
import {apiService} from 'services/ApiService';

// Components
import ErrorCard from 'components/Errors';

const ChangeRoleModal = ({user, isOpen, onClose}) => {
    const [confirm, setConfirm] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [errorCard, setErrorCard] = useState();

    const [selectedRole, setSelectedRole] = useState();

    const handleRole = (event) => {
        setSelectedRole(event.target.value);
    };

    const {data: roles} = useQuery({
        queryKey: ['roles-select'],
        refetchOnWindowFocus: false,
        queryFn: async () => {
            const response = await apiService.getRoles({
                limit: 100,
            });
            return response.data;
        },
        retry: false
    });

    const handleChange = async () => {
        setIsLoading(true);

        const body = {
            id: user?.id,
            role: selectedRole
        };

        try {
            const response = await apiService.updateUserRole(body);
            if ([200, 201].includes(response.statusCode)) {
                onClose();
                window.location.reload();
            } else {
                setErrorCard(response.message);
            }
        } catch (e) {
            setErrorCard(true);
        }

        setIsLoading(false);
    };


    const handleConfirm = () => setConfirm(!confirm);

    useEffect(() => {
        if (user) {
            setSelectedRole(user.role);
        } else {
            setSelectedRole(null);
        }
    }, [user]);
    return (
        <>
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay/>
                <ModalContent className="modal__simple" maxW={{sm: '570px'}}>
                    <ModalHeader display="flex" alignItems="left" justifyContent="left">Change role</ModalHeader>
                    <ModalCloseButton/>
                    <ModalBody>
                        <Text variant="text-md" mb="24px" pt="16px" maxW={{sm: '90%'}}>Assign a role to
                            the {user?.firstName} {user?.lastName}</Text>

                        {errorCard && (<ErrorCard error={errorCard} maxW="839px" mt="-8px" mb="16px"/>)}

                        <FormControl variant="floating" w="100%" pb='0px' mb="32px">
                            <Select onChange={handleRole} value={selectedRole} placeholder="Select Role" pb='0px'>
                                {roles?.map((item, index) => (
                                    <option key={index} value={item.name}>{item.name}</option>
                                ))}
                            </Select>
                        </FormControl>

                        <Divider opacity="1" borderColor='rgba(255, 255, 255, 0.10)' borderTopWidth="1px"
                                 borderBottomWidth="0"/>

                        <Text variant="text-md" mb="16px" pt="16px">Confirm role update for this user?</Text>

                        <Flex mb="24px">
                            <Checkbox
                                isChecked={confirm}
                                onChange={handleConfirm}
                            />
                            <Text variant="text-md" ml="10px">{'I deliberately change user\'s role'}</Text>
                        </Flex>

                        <Flex justifyContent="flex-end">
                            <Button variant="submit-md" maxW="140px" isLoading={isLoading} disabled={!confirm}
                                    onClick={handleChange}>
                                Confirm
                            </Button>
                        </Flex>
                    </ModalBody>
                </ModalContent>
            </Modal>
        </>
    );
};

export default ChangeRoleModal;
